import {
  getFormattedValue,
  getNameFormatterFromColumn,
  getValueFormatterFromColumn,
} from 'components/contexts/ColumnFormatterMapping';

const FORMATTER_TYPES = Object.freeze({
  CURRENCY: 'currency',
  NUMBER: 'number',
});

const CUSTOM_FORMATTER = {
  type: '',
  colums: [{}],
};

export default function CustomhtmlForFeature({
  title,
  subTitle,
  feature,
  formatter = CUSTOM_FORMATTER,
  includeColumns = '*',
  source = '',
}) {
  if (!feature) {
    throw new Error(`htmlForFeature needs "info.object" information`);
  }
  const propertyNames = Object.keys(feature.properties);
  if (
    formatter?.type &&
    formatter?.colums &&
    !isFormatterValid(propertyNames, formatter)
  ) {
    return;
  }
  if (!includedColumnsAreValid(propertyNames, includeColumns)) {
    return;
  }
  let html = '';
  if (title) {
    html = `<div class="deck-tooltip-title">${title}</div>`;
  }
  if (subTitle) {
    html += `<div class="deck-tooltip-subtitle">${subTitle}</div>`;
  }
  if (feature.properties) {
    html += `<div class="deck-hr"></div><div class="deck-tooltip-msg-container">`;
    if (includeColumns !== '*') {
      includeColumns.forEach((c) => {
        html += `<div class="deck-tooltip-msg-wrapper"><div class="deck-tooltip-msg-text-1">${
          getNameFormatterFromColumn(source, c)
            ? getNameFormatterFromColumn(source, c)
            : c.replace(/_/g, ' ')
        }</div><div class="deck-tooltip-msg-text-2">`;
        html += `<div>${
          getValueFormatterFromColumn(source, c)
            ? new Function('return ' + getValueFormatterFromColumn(source, c))()(
                feature.properties[c]
              )
            : getFormattedValue(feature.properties[c])
        }</div>`;
        html += `</div></div>`;
        return '';
      });
    }
  }
  return html;
}

function isFormatterValid(properties, formatter) {
  const supportedTypes = Object.values(FORMATTER_TYPES);
  if (!supportedTypes.includes(formatter.type)) {
    throw new Error(
      `"${formatter.type}" is not supported as formatter, use one of "${supportedTypes}"`
    );
  }
  if (!formatter.columns || formatter.columns.length === 0) return true;
  if (!isArrayOfStrings(formatter.columns)) {
    throw new Error(`"formatter.columns" property needs to be an array of strings`);
  }
  for (const column of formatter.columns) {
    if (!properties.includes(column)) {
      const available = properties.join(', ');
      throw new Error(
        `"formatted.columns" includes '${column}' but it was not found!. Available cols are [${available}]`
      );
    }
  }
  return true;
}

function includedColumnsAreValid(properties, includeColumns) {
  if (includeColumns === '*') {
    return true;
  }
  if (!isArrayOfStrings(includeColumns)) {
    throw new Error(
      `"includeColumns" property needs to be an array of existing feature columns or "*"`
    );
  }
  if (isArrayOfStrings(includeColumns)) {
    for (const column of includeColumns) {
      if (!properties.includes(column)) {
        throw new Error('colums set in "includeColumns" should exist in picked feature');
      }
    }
  }
  return true;
}

function isArrayOfStrings(value) {
  return Array.isArray(value) && value.length && value.every(String);
}
